<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Stat from "@/components/widgets/stat";
import Multiselect from "vue-multiselect";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Message Center",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat,
    Multiselect,
    ModelListSelect,
  },
  data() {
    return {
      title: "Message Center",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Message Center",
          active: true,
        },
      ],

      // Value from user input for adding position
      data: {
        name: "",
      },
      filteredServices: [],
      messageError: "",
      recieverError: "",
      recieverStaffError: "",
      ServiceError: "",
      categoryError: "",
      recieverGroupError: "",
      messageGroupError: "",
      messageServiceError: "",
      sendStaff: {
        message: "",
        recievers: [],
        category: "staff",
      },
      send: {
        message: "",
        recievers: [],
        category: "clients",
      },
      sendGroup: {
        message: "",
        recievers: "null",
        category: "group",
      },
      sendProduct: {
        message: "",
        category: "null",
        product: "null",
      },
      clientRecievers: 0,
      clientmsg: 0,
      clientSize: 0,
      clientTotal: 0,

      staffRecievers: 0,
      staffmsg: 0,
      staffSize: 0,
      staffTotal: 0,

      groupmsg: 0,
      groupSize: 0,

      servicemsg: 0,
      serviceSize: 0,

      groupoptions: [
        { name: "All Clients", id: "clients" },
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("customers", ["Customers"]),
    ...mapGetters("messages", ["Messages", "SendStatus","ProductData"]),
    ...mapGetters("products", ["SaveStatus", "Categories","Products"]),
  },
  mounted() {},
  watch: {
    show(newValue) {
      if (newValue == true) {
        // this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCustomers: "customers/fetchCustomers",
      FetchMessages: "messages/fetchMessageSummary",      
      SendMessage: "messages/sendMessage",
      SendMessageGroup: "messages/sendMessageGroup",
      SendMessageProduct: "messages/sendMessageProduct",
      FetchCategories: "products/fetchPCategories",
      FetchProducts: "products/fetchProducts",
      FetchProductsData: "messages/fetchProductsData",
    }),
    getValues() {
      this.messageError = "";
      if (this.send.recievers.length < 1) {
        this.recieverError = "Please select a recipient(s)";
      }
      this.clientRecievers = this.send.recievers.length;
      this.clientmsg = this.send.message.length + this.Messages.business.length;
      this.clientSize = Math.ceil(this.clientmsg / 160);
      this.clientTotal = this.clientRecievers * this.clientSize;
    },
    getValuesGroup() {
      this.messageGroupError = "";
      if (this.sendGroup.recievers == "null") {
        this.recieverGroupError = "Please select a recipient(s)";
      }
      this.groupmsg = this.sendGroup.message.length + this.Messages.business.length;
      this.groupSize = Math.ceil(this.groupmsg / 160);
    },
    getValueService() {
      this.messageServiceError = "";
      if (this.sendProduct.category == "null") {
        this.categoryError = "Please select a Product Category";
      }
      if (this.sendProduct.service == "null") {
        this.ServiceError = "Please select a Product";
      }
      this.servicemsg = this.sendProduct.message.length + this.Messages.business.length;
      this.serviceSize = Math.ceil(this.servicemsg / 160);
    },
    filterCategoryProducts() {
      if (this.sendProduct.category) {
        this.FetchProductsData(this.sendProduct);
      }
    },
    resetErrors() {
      this.recieverError = "";
      this.recieverStaffError = "";
      this.recieverGroupError = "";
      this.ServiceError = "";
      this.categoryError = "";
      this.messageError = "";
      this.messageServiceError = "";
      this.messageGroupError = "";
    },
    resetInputs() {
      this.send.recievers = [];
      this.send.message = "";
      this.sendGroup.recievers = "null";
      this.sendGroup.message = "";
      this.sendProduct.recievers = "null";
      this.sendProduct.message = "";
      this.sendProduct.category = "";
      this.sendProduct.product = "";
    },
    sendClientMsg() {
      if (this.send.message.length < 1) {
        this.messageError = "Please type the message to send";
        return;
      } else {
        this.messageError = "";
      }
      if (this.send.recievers.length < 1) {
        this.recieverError = "Please select the receipient(s)";
        return;
      } else {
        this.recieverError = "";
      }

      this.SendMessage(this.send);
      this.resetInputs();
    },
    sendGroupMsg() {
      if (this.sendGroup.message.length < 1) {
        this.messageGroupError = "Please type the message to send";
        return;
      } else {
        this.messageGroupError = "";
      }
      if (this.sendGroup.recievers.length < 1) {
        this.recieverGroupError = "Please select the receipient(s)";
        return;
      } else {
        this.recieverGroupError = "";
      }

      this.SendMessageGroup(this.sendGroup);
      this.resetInputs();
    },

    sendProductMsg() {
      if (this.sendProduct.message.length < 1) {
        this.messageServiceError = "Please type the message to send";
        return;
      } else {
        this.messageServiceError = "";
      }
      if (this.sendProduct.category == "null") {
        this.categoryError = "Please select a product category";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.sendProduct.service == "null") {
        this.ServiceError = "Please select a product group";
        return;
      } else {
        this.ServiceError = "";
      }

      this.SendMessageProduct(this.sendProduct);
      this.resetInputs();
    },
  },
  created() {
    this.FetchCustomers();
    this.FetchMessages();
    this.FetchCategories();
    this.FetchProducts();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-3">
      <div class="col-12">
        <div class="row mb-3 justify-content-around">
          <div
            class="col-6"
            style="border: 3px solid white; padding: 15px; border-radius: 5px"
          >
          <div class="row">
            <h4 class="text-primary">Message Statistics</h4>
            <div class="col-md-6">
              <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                <Stat
                  :icon="'fa fa-comments'"
                  :title="'Message Balance'"
                  :value="Messages ? Messages.smsBalance : 0"
                  :extra="'SMS'"
                />
              </div>
            </div>
            <div class="col-md-6">
                <router-link
                  :to="{
                    name: 'PurchaseLogs',
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-eye'"
                      :title="'Purchase Logs'"
                      :value="'0'"
                      :extra="'Times'"
                    />
                  </div>
                </router-link>
              </div>
          </div>
          </div>
          <div
            class="col-6"
            style="border: 3px solid white; padding: 15px; border-radius: 5px"
          >
            <div class="row">
              <h4 class="text-primary">Message Categories</h4>

              <div class="col-md-6">
                <router-link
                  :to="{
                    name: 'MessageLogs',
                    params: {
                      category: 'clients',
                    },
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-comments'"
                      :title="'Client Messages'"
                      :value="Messages ? Messages.clientSMS : '0'"
                      :extra="'SMS'"
                    />
                  </div>
                </router-link>
              </div>
              <div class="col-md-6">
                <router-link
                  :to="{
                    name: 'MessageLogs',
                    params: {
                      category: 'other',
                    },
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-comments'"
                      :title="'Group Messages'"
                      :value="Messages ? Messages.groupSMS : '0'"
                      :extra="'SMS'"
                    />
                  </div>
                </router-link>
              </div>  
              <div class="col-4"></div>
              <div class="col-4">
                <router-link
                  :to="{
                    name: 'MessageBuy',
                  }"
                >
                  <button class="btn btn-primary float-end">
                    <i class="fa fa-plus"></i> Buy Messages
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="text-success">Send Messages</h4>
                    <hr />
                    <b-tabs
                      justified
                      nav-class="nav-tabs-custom"
                      content-class="p-3 text-muted"
                    >
                      <b-tab active>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none"> SMS CLIENTS </span>
                          <span class="d-none d-sm-inline-block">SMS TO CLIENTS</span>
                        </template>
                        <p>Send Messages to the specified client</p>
                        <div class="row">
                          <div class="col-4">
                            <label>Select Client(s)</label>
                            <multiselect
                              v-model="send.recievers"
                              :height="300"
                              :options="Customers ? Customers : []"
                              :multiple="true"
                              :taggable="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              tag-placeholder="Add Reciepient"
                              placeholder="Choose Recievers"
                              label="name"
                              track-by="id"
                              @input="resetErrors(), getValues()"
                              :preselect-first="false"
                            >
                              <template slot="selection" slot-scope="{ values, isOpen }"
                                ><span
                                  class="multiselect__single"
                                  v-if="values.length &amp;&amp; !isOpen"
                                  >{{ values.length }} Clients selected</span
                                ></template
                              >
                            </multiselect>
                            <span v-if="recieverError" class="text-danger">{{
                              recieverError
                            }}</span>
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{ Messages ? Messages.business : "---" }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="send.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValues()"
                                ></textarea>
                                <div v-if="messageError" class="text-danger">
                                  Please enter a message to send.
                                </div>
                                <div
                                  v-if="send.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ clientmsg }} |
                                  <strong>Size:</strong> {{ clientSize }} |
                                  <strong>Recievers:</strong> {{ clientRecievers }} |
                                  <strong>Total SMS:</strong> {{ clientTotal }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button @click="sendClientMsg()" class="btn btn-primary">
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none"> SMS GROUPS </span>
                          <span class="d-none d-sm-inline-block">SMS TO GROUPS</span>
                        </template>
                        <p>Send Messages to Groups of people</p>
                        <div class="row">
                          <div class="col-4">
                            <label>Select Group</label>
                            <model-list-select
                              @input="resetErrors(), getValuesGroup()"
                              :list="groupoptions"
                              v-model="sendGroup.recievers"
                              option-value="id"
                              option-text="name"
                              placeholder="Select Department"
                            >
                            </model-list-select>
                            <span class="text-danger" v-if="recieverGroupError"
                              >Please select the recipient group</span
                            >
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{ Messages ? Messages.business : "---" }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="sendGroup.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValuesGroup()"
                                ></textarea>
                                <div
                                  v-if="sendGroup.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ groupmsg }} |
                                  <strong>Size:</strong> {{ groupSize }}
                                </div>
                                <span v-if="messageGroupError" class="text-danger"
                                  >Please enter a message.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button @click="sendGroupMsg()" class="btn btn-primary">
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none"> SMS OTHER </span>
                          <span class="d-none d-sm-inline-block">OTHERS</span>
                        </template>
                        <p>Send Messages to Other Groups of people</p>
                        <div class="row">
                          <div class="col-4">
                            <div class="form-group">
                            <label>Select Product Category</label>
                            <model-list-select
                              @input="resetErrors(), getValueService(), filterCategoryProducts()"
                              :list="Categories?Categories:[]"
                              v-model="sendProduct.category"
                              option-value="id"
                              option-text="catName"
                              placeholder="Select Product Category"
                            >
                            </model-list-select>
                            <span class="text-danger" v-if="ServiceError"
                              >Please select the service</span
                            >
                            </div>
                            <div class="form-group">
                            <label>Select Product</label>
                            <model-list-select
                              @input="resetErrors(), getValueService()"
                              :list="ProductData?ProductData:[]"
                              v-model="sendProduct.product"
                              option-value="id"
                              option-text="name"
                              placeholder="Select Product"
                            >
                            </model-list-select>
                            <span class="text-danger" v-if="ServiceError"
                              >Please select the service</span
                            >
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{ Messages ? Messages.business : "---" }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="sendProduct.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValueService()"
                                ></textarea>
                                <div
                                  v-if="sendProduct.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ servicemsg }} |
                                  <strong>Size:</strong> {{ serviceSize }}
                                </div>
                                <span v-if="messageServiceError" class="text-danger"
                                  >Please enter a message to be sent.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button @click="sendProductMsg()" class="btn btn-primary">
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary, .page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
